/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router-dom";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import SecondaryBtnLight from "../../common/form/SecondaryBtnLight";
import { useEffect, useState } from "react";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import moment from "moment";
import { NoAdds } from "../../common/svg/AllSvg";
import { useTranslation } from "react-i18next";
import Error from "../../common/form/Error";
import { useSelector } from "react-redux";

const FeaturedJobs = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const params = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<any>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const { t } = useTranslation('common');
    const loaderData: any[] = [1, 2]

    const getData = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`${(!!lang ? lang : "en") + url?.publicAd}`);

            if (res && res.status === 200) {
                if (res?.data?.results?.length > 0) {
                    // if (res?.data?.results?.length > 3) {
                    if (res?.data?.results?.length > 2) {
                        let arr: any[] = [{
                            "id": "4ef814ec-0a52-4ffa-ac4e-ce7f77210052",
                            "title": "NOTICE - Advt. 2025-01",
                            "adv_no": "MMRCL/HR-Rect./ 2025-01",
                            "last_date_submission": "2025-06-08",
                            "attach_pdf": "https://mmrcl-development.s3.amazonaws.com/media/documents/2459_001.pdf",
                            "status": "closed"
                        }]
                        // for (let i = 0; i < 3; i++) {
                        for (let i = 0; i < 2; i++) {
                            const el = res?.data?.results[i];
                            // if (el?.status === "open") {
                            arr.push(el)
                            // }
                        }
                        setData(arr)
                    } else {
                        let arr: any[] = [{
                            "id": "4ef814ec-0a52-4ffa-ac4e-ce7f77210052",
                            "title": "NOTICE - Advt. 2025-01",
                            "adv_no": "MMRCL/HR-Rect./ 2025-01",
                            "last_date_submission": "2025-06-08",
                            "attach_pdf": "https://mmrcl-development.s3.amazonaws.com/media/documents/2459_001.pdf",
                            "status": "closed"
                        }];
                        let arr1: any = arr.concat(res?.data?.results)
                        setData(arr1)
                        // setData(res?.data?.results)
                    }
                }
                setLoading(false)
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while fetching adds", error);
        }
    }

    useEffect(() => {
        !!lang && getData();
    }, [lang])

    return (
        <div className="w-full h-full bg-[#F6F9FC] dark:bg-bgDark py-[30px] lg:py-[64px]">
            <div className="container h-full flex flex-col gap-[30px] lg:gap-[42px]">
                <div className="flex flex-col w-full items-center justify-center">
                    {/*<h3 className="text-blackDark dark:text-textBlackDark font-medium">Find the job that’s perfect for you.</h3>*/}
                    <h1 className="font-bold text-[#A5AE39]">{t("recruitment.home.current_openings")}</h1>
                </div>

                {loading ?
                    <div className="overflow-x-auto h-full w-full">
                        <div className="inline-block min-w-full">
                            <div className="overflow-hidden">
                                <table className="table-auto w-full">
                                    <thead className="w-full">
                                        <tr className="w-full bg-[#D9D9D9] dark:border-[#454545] bg-opacity-[0.3] border border-[#D9D9D9] border-opacity-[0.3]">
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-center">
                                                {t("recruitment.home.ads_list.s_no")}
                                            </th>
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                {t("recruitment.home.ads_list.add_no")}
                                            </th>
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                {t("recruitment.home.ads_list.title")}
                                            </th>
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                {t("recruitment.home.ads_list.last_date")}
                                            </th>
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-center">
                                                {t("recruitment.home.ads_list.status")}
                                            </th>
                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                            <tr className="w-full animate-pulse border border-gray-200 dark:border-gray-700 bg-white dark:bg-bgDarkDull" key={index}>
                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="flex items-center justify-center">
                                                        <div className="w-[20px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                    </div>
                                                </td>

                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="flex flex-col gap-[8px]">
                                                        <div className="w-[180px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                        <div className="w-[90px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                    </div>
                                                </td>

                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="w-[180px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                </td>

                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                </td>

                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="flex items-center justify-center">
                                                        <div className="w-[80px] h-[25px] xlx:h-[30px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                    </div>
                                                </td>

                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                    <div className="flex items-center justify-end">
                                                        <div className="w-[60px] xlx:w-[94px] rounded-[4px] h-[35px] xlx:h-[40px] bg-gray-200 dark:bg-gray-700"></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    :
                    <>
                        {isError ? <Error /> : <>
                            {data?.length > 0 ? <>
                                <div className="flex flex-col gap-[30px] lg:gap-[35px] w-full items-center justify-center">
                                    <div className="overflow-x-auto h-full w-full">
                                        <div className="inline-block min-w-full">
                                            <div className="overflow-hidden">
                                                <table className="table-auto w-full">
                                                    <thead className="w-full">
                                                        <tr className="w-full bg-[#D9D9D9] dark:border-[#454545] bg-opacity-[0.3] border border-[#D9D9D9] border-opacity-[0.3]">
                                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-center">
                                                                {t("recruitment.home.ads_list.s_no")}
                                                            </th>
                                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                                {t("recruitment.home.ads_list.add_no")}
                                                            </th>
                                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                                {t("recruitment.home.ads_list.title")}
                                                            </th>
                                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-left">
                                                                {t("recruitment.home.ads_list.last_date")}
                                                            </th>
                                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-[#121212] dark:text-white font-bold text-sm leading-snug !text-center">
                                                                {t("recruitment.home.ads_list.status")}
                                                            </th>
                                                            <th className="px-[16px] py-[3px] xlx:py-[6px] h-full"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.isArray(data) && data.map((item: any, index: number) => (
                                                            <tr className={`${((index % 2) === 0) ? "bg-[#FCFCFC] dark:bg-[#343539]" : "bg-[#F6F9FC] dark:bg-[#3f4143]"} border border-[#E5E5E5] dark:border-[#454545]`} key={index}>
                                                                <td className="px-[16px] py-[15px] xlx:py-[30px] text-base font-medium text-blackDark dark:text-textBlackDark text-center">
                                                                    {index + 1}.
                                                                </td>
                                                                <td className="px-[16px] py-[15px] xlx:py-[30px] text-base *:text-base font-medium text-blackDark dark:text-textBlackDark">
                                                                    <div className="w-[210px] xlx:w-[240px]">
                                                                        {/* w-[350px] xlx:w-[390px] */}
                                                                        {item?.title}
                                                                    </div>
                                                                </td>
                                                                <td className="px-[16px] py-[15px] xlx:py-[30px] text-base *:text-base font-medium text-blackDark dark:text-textBlackDark">
                                                                    <div className="w-[210px] xlx:w-[240px]">
                                                                        {item?.adv_no}
                                                                    </div>
                                                                </td>
                                                                <td className="px-[16px] py-[15px] xlx:py-[30px] text-base font-medium text-blackDark dark:text-textBlackDark whitespace-nowrap">
                                                                    {moment(item?.last_date_submission).format('MMM DD, YYYY')}
                                                                </td>

                                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                                    <div className="flex items-center justify-center">
                                                                        <div className={`${item?.status?.toLowerCase() === "open" ? "bg-[rgba(0,128,0,0.10)] text-[#008000] dark:bg-[#1f8642] dark:text-white" : "bg-[rgba(255,0,0,0.10)] text-danger dark:bg-[#c86161] dark:text-white"} px-[20px] h-[25px] xlx:h-[30px] flex items-center justify-center w-fit text-base font-medium rounded-[30px] capitalize`}>
                                                                            {item?.status}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="px-[16px] py-[15px] xlx:py-[30px]">
                                                                    <div className="flex items-center justify-center">
                                                                        <SecondaryBtn title={t("recruitment.home.view")} css="px-[15px] xlx:px-[30px] uppercase font-bold" onClick={() => { index === 0 ? window.open(item?.attach_pdf, '_blank') : !!params?.lang ? navigate(`/${params?.lang}/vacancies/${item?.id}`) : navigate(`/vacancies/${item?.id}`) }} />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <SecondaryBtnLight title={t("recruitment.home.view_all")} css="uppercase font-extrabold rounded-[6px] text-base px-[35px] xlx:px-[41px] dark:text-textBlackDark dark:border-textBlackDark dark:focus:shadow-[0_0_0_3px_#ffffff5e] dark:hover:shadow-[0_0_0_3px_#ffffff5e]" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/vacancies`) : navigate("/vacancies")} />
                                </div>
                            </> : <>
                                <div className="flex flex-col items-center justify-center py-[100px]">
                                    <NoAdds />

                                    <div className="flex flex-col items-center justify-center gap-[4px] mt-[25px]">
                                        <h3 className="text-primaryText dark:text-white font-bold">{t("recruitment.home.no_ads.title")}</h3>
                                        <h5 className="text-blackDull dark:text-textBlackDull font-medium text-center">{t("recruitment.home.no_ads.desc")}</h5>
                                    </div>
                                </div>
                            </>}
                        </>}
                    </>}
            </div>
        </div>
    );
};

export default FeaturedJobs;